module.exports = __webpack_public_path__ + "img/wemachurchplus.916ba1f1.png";